import { fillVariants } from "../../../styles/utils/fill"
import { classNames } from "../../../utils"
import type { IconProps } from "../../types"

// https://fonts.google.com/icons?selected=Material+Symbols+Outlined:swap_horiz:FILL@0;wght@400;GRAD@0;opsz@24&icon.query=swap
export const SwapHoriz = ({
  size = 24,
  className,
  fill = "current",
  fillAttribute = "currentColor",
  ...rest
}: IconProps) => {
  return (
    <svg
      aria-label="Swap"
      className={classNames(fillVariants({ fill }), className)}
      fill={fillAttribute}
      height={size}
      role="img"
      viewBox="0 -960 960 960"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M280-160 80-360l200-200 56 57-103 103h287v80H233l103 103-56 57Zm400-240-56-57 103-103H440v-80h287L624-743l56-57 200 200-200 200Z" />
    </svg>
  )
}
